import { useCopilotContext } from '@/lib/features/copilotv2/CopilotContext'
import { forwardRef } from 'react'
import { FaChevronDown, FaRedo } from 'react-icons/fa'

interface RetryButtonProps {
  onClick: () => void
  isRetrying?: boolean
}

export const RetryButton = forwardRef<HTMLButtonElement, RetryButtonProps>(
  ({ onClick, isRetrying = false }, ref) => {
    const { status } = useCopilotContext()
    const isConnectionActive = status === 'streaming'

    return (
      <button
        ref={ref}
        onClick={(e) => {
          e.stopPropagation()
          onClick()
        }}
        disabled={isRetrying || isConnectionActive}
        className="flex items-center gap-1 rounded-lg bg-blue-100 px-2 py-1 text-sm font-medium text-blue-700 transition-colors hover:bg-blue-200 disabled:cursor-not-allowed disabled:opacity-50"
        title={
          isConnectionActive
            ? 'Cannot retry while Copilot is actively responding'
            : 'Retry from this node'
        }
      >
        <FaRedo size={12} className={isRetrying ? 'animate-spin' : ''} />
        <span>Retry</span>
        <FaChevronDown size={10} />
      </button>
    )
  }
)

RetryButton.displayName = 'RetryButton'
